/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModelUtils } from '../../cmd/util/ModelUtils';
import { JsonCompat } from '../../compat/JsonCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { RegexCompat } from '../../compat/RegexCompat';
import { DocumentType } from '../models/DocumentType';
import { IDefinition } from '../models/common/IDefinition';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class OasSchemaFactory {
    /*private*/ static resolveType(thing : any, schema : OasSchema) {
        if(JsonCompat.isNumber(thing)) {
            let value : number = JsonCompat.toNumber(thing);
            let isInteger : boolean = ("" + value).indexOf(".") === -1;
            if(isInteger) {
                schema.type = "integer";
                if(/* intValue */(value|0) >= -2147483647 && /* intValue */(value|0) <= 2147483647) {
                    schema.format = "int32";
                } else if(/* longValue */value >= -9223372036854775807 && /* longValue */value <= 9223372036854775807) {
                    schema.format = "int64";
                }
            } else {
                schema.type = "number";
                schema.format = "double";
            }
        } else if(JsonCompat.isBoolean(thing)) {
            schema.type = "boolean";
        } else if(JsonCompat.isArray(thing)) {
            schema.type = "array";
        } else if(JsonCompat.isObject(thing)) {
            schema.type = "object";
        } else if(JsonCompat.isString(thing)) {
            let value : string = JsonCompat.toString(thing);
            schema.type = "string";
            if(RegexCompat.matches(value, "^(\\d{4})\\D?(0[1-9]|1[0-2])\\D?([12]\\d|0[1-9]|3[01])$")) {
                schema.format = "date";
            } else if(RegexCompat.matches(value, "^(\\d{4})\\D?(0[1-9]|1[0-2])\\D?([12]\\d|0[1-9]|3[01])(\\D?([01]\\d|2[0-3])\\D?([0-5]\\d)\\D?([0-5]\\d)?\\D?(\\d{3})?([zZ]|([\\+-])([01]\\d|2[0-3])\\D?([0-5]\\d)?)?)?$")) {
                schema.format = "date-time";
            }
        } else if(JsonCompat.isNull(thing)) {
            schema.type = "string";
        }
    }

    /*private*/ static resolveAll(object : any, schema : OasSchema) {
        OasSchemaFactory.resolveType(object, schema);
        if(NodeCompat.equals(schema.type, "array")) {
            schema.items = schema.createItemsSchema();
            let list : Array<any> = JsonCompat.toList(object);
            if(/* size */(<number>list.length) > 0) {
                OasSchemaFactory.resolveAll(/* get */list[0], <OasSchema>schema.items);
            }
        } else if(NodeCompat.equals(schema.type, "object")) {
            schema.type = "object";
            let keys : Array<string> = JsonCompat.keys(object);
            for(let index121=0; index121 < keys.length; index121++) {
                let propName = keys[index121];
                {
                    let pschema : OasSchema = schema.createPropertySchema(propName);
                    schema.addProperty(propName, pschema);
                    let propValue : any = JsonCompat.getProperty(object, propName);
                    OasSchemaFactory.resolveAll(propValue, pschema);
                }
            }
        }
    }

    /**
     * Creates a new definition schema from a given example.  This method will analyze the example
     * object and create a new schema object that represents the example.  Note that this method
     * does not support arbitrarily complicated examples, and should be used as a starting point
     * for a schema, not a canonical one.
     * @param {OasDocument} document
     * @param {string} name
     * @param {*} example
     * @return {*}
     */
    public static createSchemaDefinitionFromExample(document : OasDocument, name : string, example : any) : IDefinition {
        let schema : OasSchema = null;
        if(document.getDocumentType() === DocumentType.openapi2) {
            let doc20 : Oas20Document = <Oas20Document>document;
            if(ModelUtils.isNullOrUndefined(doc20.definitions)) {
                doc20.definitions = doc20.createDefinitions();
            }
            schema = doc20.definitions.createSchemaDefinition(name);
        } else if(document.getDocumentType() === DocumentType.openapi3) {
            let doc30 : Oas30Document = <Oas30Document>document;
            if(ModelUtils.isNullOrUndefined(doc30.components)) {
                doc30.components = doc30.createComponents();
            }
            schema = doc30.components.createSchemaDefinition(name);
        } else {
            throw Object.defineProperty(new Error("Only OpenAPI 2 and 3 are currently supported."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        }
        if(JsonCompat.isString(example)) {
            example = JsonCompat.parseJSON(JsonCompat.toString(example));
        }
        OasSchemaFactory.resolveAll(example, schema);
        schema.title = "Root Type for " + name;
        schema.description = "The root of the " + name + " type\'s schema.";
        return <IDefinition><any>schema;
    }
}
OasSchemaFactory["__class"] = "io.apicurio.datamodels.core.factories.OasSchemaFactory";



